import styled from 'styled-components';

export const FieldLabelText = styled.label`
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  flex: 1;
  padding: 0 6px 0 6px;
`;

export default FieldLabelText;
